import { createSlice } from "@reduxjs/toolkit";

const parameterCalculatedEditSlice = createSlice({
  name: "parameterCalculatedEdit",
  initialState: {
    currentParametroCalculado: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    parametroStart: (state) => {
      state.isFetching = true;
    },
    parametroSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametroCalculado = action.payload;
    },
    parametroFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    updateStart: (state) => {
      state.currentParametroCalculado = null;
      state.isFetching = true;
      state.error = false;
    },
    updateSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametroCalculado = action.payload;
      state.error = false;
    },
    updateFailure: (state) => {
      state.currentParametroCalculado = null;
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  parametroStart,
  parametroSuccess,
  parametroFailure,
  updateStart,
  updateSuccess,
  updateFailure,
} = parameterCalculatedEditSlice.actions;
export default parameterCalculatedEditSlice.reducer;
